import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { OrderCancelationModel, OrderModel, OrderServiceProxy, PaymentCreateModel, PaymentStatus, PaymentType } from '../../../../shared/service-proxies/event-service-proxy';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { ToastrService } from '../../../services/toastr/toastr.service';
import { ErrorService } from '../../../services/error/error.service';

@Component({
    selector: 'app-modal-order-cancel',
    templateUrl: './modal-order-cancel.component.html',
    styleUrl: './modal-order-cancel.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class ModalOrderCancelComponent implements OnInit{
  @Input() orderId: string = '';
  @Input() order: OrderModel = new OrderModel();
  @Output() change = new EventEmitter<boolean>(false);

  isLoadingSend: boolean = false;

  orderCancelForm: OrderCancelationModel = new OrderCancelationModel();

  constructor(private toastrService: ToastrService, private errorService: ErrorService, private modalService: ModalService, private _orderService: OrderServiceProxy, private destroyService: DestroyService) { }

  ngOnInit(): void {
    this.initialize();
  }

  initialize() {
    if (!this.orderCancelForm.payment) {
      this.orderCancelForm.payment = new PaymentCreateModel();
    }
  }

  orderCancel() {
    this.isLoadingSend = true;
    this.orderCancelForm.properties = [];
    this.orderCancelForm.payment.status = PaymentStatus.Completed;
    this.orderCancelForm.payment.type = PaymentType.Refund;
    this.orderCancelForm.payment.currency = this.order.currency;
    this._orderService.cancel(this.orderId, this.orderCancelForm)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
        console.log(res);
        this.isLoadingSend = false;
        this.change.emit(true);
        this.closeModal();
        this.toastrService.showSuccessToastr('Заказ успешно отменён!');
      }, error => {
        console.error(error);
        this.isLoadingSend = false;
        this.errorService.handleError(error, 'Не удалось отменить заказ. Попробуйте позже.');
    })
  }

  closeModal() {
    this.modalService.closeModal();
    this.clearFormData();
  }

  clearFormData() {
    this.orderCancelForm = new OrderCancelationModel();
    this.initialize();
  }
}
